import { CircularProgress } from "@mui/material";

const LoadingIndicator = () => {
    return (
        <CircularProgress style={{ color: "white" }} size={16} />
    );
}

export default LoadingIndicator;